export default __webpack_public_path__ + "static/media/interface-1.deaddd46.png";